import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { MassiveClosePayload, MassiveCloseRequestBody, MassiveCloseResponse } from './massive-close.types';

function buildMassiveCloseRequestBody(
  body: MassiveClosePayload['body'],
  accept_protocol_invalidation: boolean
): MassiveCloseRequestBody {
  return {
    silobags: body.map(({ id }) => ({ id })),
    accept_protocol_invalidation,
  };
}

// deprecated service ref.: massiveCloseService_DEPRECATED
export async function silobagMassiveCloseService({
  body,
  accept_protocol_invalidation,
}: MassiveClosePayload) {
  const requestBody = buildMassiveCloseRequestBody(body, accept_protocol_invalidation ?? false);

  const { response, data } = await BACKEND.post<MassiveCloseResponse>(ENDPOINT.SILOBAGS_MASSIVE_CLOSE, {
    body: requestBody,
  });

  return {
    response,
    summary: data,
  };
}
